// extracted by mini-css-extract-plugin
export var redirectLink = "style-module--redirectLink--24fT4";
export var logoContainer = "style-module--logoContainer--f1c8I";